import type { PropsWithChildren } from "react";
import type { FlexProps } from "@chakra-ui/react";
import { Flex, useMultiStyleConfig } from "@chakra-ui/react";
import { ContentContainer } from "@/components/ContentContainer/ContentContainer";

export interface ContentGroupProps extends FlexProps {
	variant?: string;
	hideIfEmpty?: boolean;
	shouldApplySmallScreenPadding?: boolean;
}

export const ContentGroup = ({
	children,
	variant,
	hideIfEmpty = false,
	bgColor = "shade.100",
	bgImage,
	background,
	backgroundImage,
	borderTop = "1px solid #E2E2E2",
	top,
	position,
	zIndex,
	width,
	shouldApplySmallScreenPadding = true,
	...rest
}: PropsWithChildren<ContentGroupProps>) => {
	const styleParts = useMultiStyleConfig("ContentGroup", { variant });
	return (
		<Flex
			data-testid="ContentGroup"
			className={`ContentGroup${hideIfEmpty ? ` hideIfEmpty` : ``}`}
			bgColor={bgColor}
			bgImage={bgImage}
			background={background}
			backgroundImage={backgroundImage}
			borderTop={borderTop}
			position={position}
			top={top}
			zIndex={zIndex}
			{...(styleParts.root as FlexProps)}
		>
			<ContentContainer className="ContentContainer" shouldApplySmallScreenPadding={shouldApplySmallScreenPadding}>
				<Flex className="Content" data-testid="ContentGroup_Content" {...(styleParts.content as FlexProps)} {...rest}>
					{children}
				</Flex>
			</ContentContainer>
		</Flex>
	);
};
